import React from 'react';
import { connect } from 'react-redux';
import { IPOActions } from '@/actions/trading';
import '@/assets/styles/components/ipo/application.scss';
import { SERVICES_RESP } from '@/configurations';
import { APP_SETTING_ACTION, REFRESH_DATA } from '@/constants/app';
import { dataType } from '@/constants/data-type';
import { PARAMS } from '@/constants/params';
import { Comparator, utilsFunction } from '@/helpers/functions';
import DataTable from '../../DataTable/DataTable';

class Application extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this)
    this.state = {
      columnDefs: [
        {
          headerName: props.language.common_ipo_actions,
          colId: 'common_actions',
          headerClass: 'table-header text-center',
          cellClass: 'table-cell cell-action',
          dataType: dataType.IPO_CELL_RENDER,
          sortable: false,
          minWidth: window.innerWidth <= 1200 ? 170 : 180
        },
        {
          headerName: props.language.common_symbol,
          colId: 'common_symbol',
          field: 'customSymbol',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.common_name,
          colId: 'common_name',
          field: 'instrumentShortname',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.STOCK_NAME,
          minWidth: 300,
          tooltipField: utilsFunction.switchToolTipsLanguage(this.props.language, 'instrumentShortname', 'instrumentChineseShortName'),
          cellRendererParams: {
            stockName: 'instrumentShortname',
            chineseStockName: 'instrumentChineseShortName'
          }
        },
        {
          headerName: props.language.ipo_issue_day,
          colId: 'ipo_issue_day',
          field: 'eipostartDate',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.DATE_TIME
        },
        {
          headerName: props.language.common_currency,
          colId: 'common_currency',
          field: 'currencyID',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
          width: 100
        },
        {
          headerName: props.language.common_offer_price_two,
          colId: 'common_offer_price_two',
          field: 'customOfferPrice',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-right',
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.ipo_lot_size,
          colId: 'ipo_lot_size',
          field: 'lotsize',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator
        },
        {
          headerName: props.language.ipo_listing_date,
          colId: 'ipo_listing_date',
          field: 'listingDate',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SHORT_DATE
        },
        {
          headerName: props.language.ipo_closing_date,
          colId: 'ipo_closing_date',
          field: 'customClosingDate',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.LONG_DATE,
          minWidth: window.innerWidth <= 1200 ? 170 : 180
        },
        {
          headerName: props.language.ipo_time_remaining,
          colId: 'ipo_time_remaining',
          field: 'customTimeRemain',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.IPO_CELL_RENDER,
          comparator: Comparator.comparatorByTimeRemainIPO,
          minWidth: 200
        }
      ],
      data: null
    }
  }

  render() {
    const { columnDefs, data } = this.state;

    return (
      <React.Fragment>
        <div className="application-container">
          <DataTable
            innerRef={e => this.tableRef = e}
            columnDefs={columnDefs}
            data={data} />
        </div>
      </React.Fragment>
    )
  }

  getData = () => {
    const { currentTradingAccount, language, clientID } = this.props
    const { tradingAccSeq } = currentTradingAccount;

    if (clientID) {
      if (this.tableRef) {
        this.tableRef.toggleLoadingOverlay(true);
      }
      const params = {
        [PARAMS.CLIENT_ID]: clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: clientID,
        [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
        [PARAMS.LANGUAGE]: language.lang
      }
      this.props.getApplication(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.modifyResponse(res.result.itemList);
            this.props.toggleRefreshTable(false)
          } else {
            this.setState({ data: [] })
          }
        }
        this.tableRef.toggleLoadingOverlay(false);
      })
    }
  }

  modifyResponse(data) {
    data.map(item => {
      item.customSymbol = `${item.marketID}.${item.instrumentID}`;
      item.customClosingDate = `${item.eipoendDate} ${item.eipoendTime}`;
      if (item.minOfferPrice && item.maxOfferPrice){
        item.customOfferPrice = `${item.minOfferPrice} ~ ${item.maxOfferPrice}`;
      }
    })
    const arr = data.filter(v => v.status === 'O')
    this.setState({ data : arr})
  }

  componentDidUpdate(prevProps) {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
      this.getData()
    }
    if (this.props.clientID !== prevProps.clientID) {
      this.getData();
    }

    if (this.props.isNeedRefresh && this.props.isNeedRefresh !== prevProps.isNeedRefresh) {
      this.getData()
    }

    if (this.props.language && this.props.language !== prevProps.language) {
      this.getData()
    }
  }


  componentDidMount() {
    this.getData();
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }
}

Application.defaultProps = {
  innerRef: () => { }
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    clientID: state.trade.clientID,
    isNeedRefresh: state.refresh.ipoAction
  }),
  dispatch => ({
    getApplication: (p, res) => dispatch(IPOActions.getApplicationAction(p, res)),
    toggleRefreshTable: (p) => dispatch({
      type: REFRESH_DATA.IPO_ACTION,
      value: p
    })
  })
)(Application)
